import { ExtractPropTypes, PropType } from 'vue'

/**
 * 日历类型
 */
export type CalendarType = 'date' | 'datetime' | 'time' | 'month' | string

/**
 * 日历大小
 */
export type CalendarSize = 'large' | string

/**
 * 范围类型
 */
export type CalendarRangeType = '' | 'end' | string

/**
 * 重点日期数据类型
 */
export type CalendarPointData = {
	/**
	 * 日期，格式：YYYY-MM-DD
	 */
	day: string
	/**
	 * 提示信息
	 */
	tooltip?: string
	/**
	 * 数量
	 */
	count?: number
	/**
	 * 类型：-1=danger, 0=primary, 1=success
	 */
	type?: number
}

/**
 * 日历值类型
 */
export type CalendarValueType = string | Date

export const calendarProps = {
	/**
	 * 假期，用于显示假期标识
	 */
	holiday: {
		type: Array as PropType<string[]>,
		default: () => []
	},
	/**
	 * 重点日期（比如这天有待办之类的）
	 */
	point: {
		type: Array as PropType<CalendarPointData[]>,
		default: () => []
	},
	/**
	 * 日历类型
	 */
	type: {
		type: String as PropType<CalendarType>,
		default: ''
	},
	/**
	 * 大小，支持 large
	 */
	size: {
		type: String as PropType<CalendarSize>,
		default: ''
	},
	/**
	 * 是否显示 point 提示信息
	 */
	legend: {
		type: Boolean,
		default: false
	},
	/**
	 * 绑定值
	 */
	modelValue: {
		type: [String, Date] as PropType<CalendarValueType>,
		default: ''
	},
	/**
	 * 范围类型
	 * 开始：''
	 * 结束：'end'
	 */
	rangeType: {
		type: String as PropType<CalendarRangeType>,
		default: ''
	},
	/**
	 * 是否为范围选择
	 */
	range: {
		type: Boolean,
		default: false
	},
	/**
	 * 是否为多选
	 */
	multiple: {
		type: Boolean,
		default: false
	},
	/**
	 * 时间
	 */
	time: {
		type: String,
		default: ''
	},
	/**
	 * 变更前回调
	 */
	beforeChange: {
		type: Function as PropType<(value: string) => boolean | Promise<boolean>>,
		default: null
	},
	/**
	 * 最小值
	 */
	min: {
		type: [String, Date, Number] as PropType<string | Date | number>,
		default: ''
	},
	/**
	 * 最大值
	 */
	max: {
		type: [String, Date, Number] as PropType<string | Date | number>,
		default: ''
	},
	/**
	 * 禁用日期
	 */
	disabledDate: {
		type: Function as PropType<(date: Date) => boolean>,
		default: null
	},

	width: {
		type: String,
		default: ''
	},
	maxYear: {
		type: [String, Number] as PropType<string | number>,
		default: 0
	},
	minYear: {
		type: [String, Number] as PropType<string | number>,
		default: 0
	},
	flex: Boolean
}

export type CalendarProps = ExtractPropTypes<typeof calendarProps>
